<template>
    <div class="row row-xs">
        <div class="col-md-8 mg-t-10">
            <div class="card">
                <div class="card-header pd-y-20 d-md-flex align-items-right justify-content-between" style="right: 0">
                    <h6 class="mg-b-0">State Stats</h6>
<!--                    <ul class="list-inline d-flex mg-t-20 mg-sm-t-10 mg-md-t-0 mg-b-0">-->
<!--                    </ul>-->
                </div><!-- card-header -->
                <div class="card-body mb-12 pos-relative pd-0">
                    <div class="chart-two mg-b-14">
                        <p v-if="loan.chartLoading" align="center"><bar-loader  class="custom-class" color="#6d0606" loading="loading" :size="150" sizeUnit="px"></bar-loader></p>
                        <bar-chart v-else style="height: 28vh; width: 100%;" class="mt-0" :data="stateData" :option="retentionOptions"></bar-chart>
                    </div><!-- chart-two -->
                </div><!-- card-body -->
            </div><!-- card -->
        </div>
        <div class="col-md-4 mg-t-10">
            <div class="card">
                <div class="card-header pd-y-20 d-md-flex align-items-right justify-content-between" style="right: 0">
                    <h6 class="mg-b-0">Gender</h6>
<!--                    <p class="tx-12 tx-color-03 mg-b-0">Percentage of completion</p>-->
                </div><!-- card-header -->
                <div class="card-body mb-12 pos-relative pd-0">
                    <div class="chart-two mg-b-14">
                        <p v-if="loan.chartLoading" align="center"><bar-loader  class="custom-class" color="#6d0606" loading="loading" :size="150" sizeUnit="px"></bar-loader></p>
                        <bar-chart v-else style="height: 28vh; width: 100%;" class="mt-0" :data="genderData" :option="retentionOptions"></bar-chart>
                    </div><!-- chart-two -->
                </div><!-- card-body -->
            </div><!-- card -->
        </div>
    </div>
</template>

<script>
    import BarChart from "../chart/BarChart";
    import {mapState} from 'vuex'
    // import LineChart from "../chart/LineChart";
    export default {
        name: "Growth",
        components:{
            BarChart,
        },
        data:()=>{
            return{
                fields: [
                    { key: 'id', label: 'S/N', sortable: true, sortDirection: 'desc' },
                    { key: 'name', label: 'Name', sortable: true, sortDirection: 'desc' },
                    { key: 'updated', label: 'Updated?', sortable: true, class: 'text-center' },
                    { key: 'verified', label: 'Verified?', sortable: true, class: 'text-center' }
                ],
                colors:[
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(255, 206, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                    'rgba(150, 102, 255, 0.2)',
                    'rgba(153, 102, 255, 0.2)',
                    'rgba(133, 206, 234, 0.2)',
                    'rgba(153, 102, 255, 0.2)',
                    'rgba(143, 102, 255, 0.2)',
                    'rgba(153, 206, 222, 0.2)',
                    'rgba(193, 102, 255, 0.2)',
                    'rgba(153, 102, 253, 0.2)',
                    'rgba(103, 102, 255, 0.2)',
                    'rgba(153, 206, 204, 0.2)',
                    'rgba(253, 102, 101, 0.2)',
                    'rgba(153, 102, 109, 0.2)',
                    'rgba(206, 102, 200, 0.2)',
                    'rgba(153, 102, 094, 0.2)',
                    'rgba(153, 102, 222, 0.2)',
                    'rgba(153, 206, 255, 0.2)',
                    'rgba(153, 102, 234, 0.2)',
                    'rgba(206, 102, 99, 0.2)',
                    'rgba(255, 159, 64, 0.2)'
                ],
                revenueOptions: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },
                    responsive: true,
                    maintainAspectRatio: false
                },
                retentionOptions: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },
                    responsive: true,
                    maintainAspectRatio: false
                }
            }
        },
        computed:{
            ...mapState([
                'loan'
            ]),
            genderChart(){
                return  this.loan.loanChart.gender
            },
            stateChart(){
                return  this.loan.loanChart.state
            },
            items:{
                get(){
                    return this.loan.dashboard.data
                },
                set(val){
                    this.$store.commit('loan/updateLoanChart', val)
                }
            },
            genderData:{
                get(){
                    return {
                        labels: [...new Set(this.genderChart.map(data => data.gender))],
                        datasets: [
                            {
                                label: '',
                                data:[...new Set(this.genderChart.map(data => data.gender))].map(
                                    it => this.genderChart.filter(
                                        log => log.gender === it).reduce(
                                        (init, curr) => (
                                            init+=parseFloat(curr.loans==null?'0.00':curr.loans)
                                        ),0)
                                ),
                                backgroundColor: this.colors,
                                borderColor: this.colors,
                                borderWidth: 1
                            }
                        ]
                    }
                },
                set(val){
                    this.$store.commit('loan/updateLoanChart', val)
                }
            },
            stateData:{
                get(){
                    return {
                        labels: [...new Set(this.stateChart.map(data => data.state))],
                        datasets: [{
                            label: '',
                            data:[...new Set(this.stateChart.map(data => data.state))].map(
                                it => this.stateChart.filter(
                                    log => log.state === it).reduce(
                                    (init, curr) => (
                                        init+=parseFloat(curr.loans==null?'0.00':curr.loans)
                                    ),0)
                            ),
                            backgroundColor: this.colors,
                            borderColor: this.colors,
                            borderWidth: 1
                        }]
                    }
                },
                set(val){
                    this.$store.commit('loan/updateLoanChart', val)
                }
            },
        },
        created(){
            //this.$store.dispatch('loan/updateLoanCharts', {})
        }
    }
</script>

<style scoped>

</style>